<div class="please-login">
  <div class="text">
    {{ this.isLoggedIn ? 'Welcome to' : 'Please login to' }}
  </div>
  <img src="/assets/images/Logo_CareHub.png" alt="CareHub" />
</div>
